module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/caterers-921103cdaffe88119d023465d648724f.webp";